import React, { useState, useRef } from 'react';
import { FiPlus, FiPlay, FiVolume2 } from 'react-icons/fi';

const ProductCard = ({ product, onAddToCart }) => {
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  // Fonction pour gérer la lecture au survol
  const handleMouseEnter = () => {
    setIsHovered(true);
    if (videoRef.current) {
      videoRef.current.play().catch(error => console.log("Auto-play bloqué"));
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0; // Remettre au début
    }
  };

  return (
    <div 
      className="group bg-white rounded-2xl opacity-0 animate-fadeIn scroll-mt-20 shadow-sm border border-slate-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-slate-100">
        {/* Affichage de l'image (cachée si vidéo en lecture au survol) */}
        <img
          src={product.image_url || '/placeholder-image.jpg'}
          alt={product.name}
          className={`w-full h-full object-cover transition-opacity duration-500 ${
            isHovered && product.video_url ? 'opacity-0' : 'opacity-100'
          }`}
        />

        {/* Lecteur Vidéo (affiché uniquement si video_url existe) */}
        {product.video_url && (
          <div className={`absolute inset-0 transition-opacity duration-500 ${
            isHovered ? 'opacity-100' : 'opacity-0'
          }`}>
            <video
              ref={videoRef}
              src={product.video_url}
              loop
              muted
              playsInline
              className="w-full h-full object-cover"
            />
            {/* Badge Indicateur Vidéo */}
            {!isHovered && (
              <div className="absolute bottom-3 right-3 bg-black/50 backdrop-blur-sm text-white p-2 rounded-full">
                <FiPlay size={14} fill="white" />
              </div>
            )}
          </div>
        )}

        {/* Badge Catégorie */}
        <div className="absolute top-3 left-3">
          <span className="bg-white/90 backdrop-blur-md text-slate-800 text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-full shadow-sm">
             {product.category_info?.name || "Optique" }
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-lg font-bold text-slate-800 mb-1">{product.name}</h3>
        <p className="text-slate-500 text-sm mb-4 line-clamp-2 h-10">{product.description}</p>
        
        <div className="flex items-center justify-between pt-4 border-t border-slate-50">
          <span className="text-xl font-black text-blue-600">
            {Math.round(product.price).toLocaleString()} <span className="text-xs font-normal">FCFA</span>
          </span>
          <button
            onClick={() => onAddToCart(product)}
            className="p-3 bg-slate-900 text-white rounded-xl hover:bg-blue-600 transition-all active:scale-95 shadow-lg shadow-slate-200"
          >
            <FiPlus size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;